import React, { useState,useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { MoveLeft } from 'lucide-react';
import wave from "../assets/Logo/wave.png";
import logo from "../assets/Logo/codematrixLogo.png";
import { Shield } from 'lucide-react';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import axiosClient from "../api/axiosClient";


const AdminLogin = () => {

  // responsive for mobile
   const [isMobile, setIsMobile] = useState(window.innerWidth < 770);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = {
    container: {
      position: "fixed",
      inset: 0,
      display: "flex",
      flexDirection: isMobile ? "column" :  "",
      width: "100%",
      height: "100vh",
      fontFamily: "Poppins, sans-serif",
      overflowX: "hidden",
      background: isMobile? "linear-gradient(135deg, #ffffff, #f3efff)"  : "#f8f6ff",
    },

    left: {
      flex: 1,
      // padding: "60px",
      marginBottom:"20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      background: isMobile? ""  : "linear-gradient(135deg, #ffffff, #f3efff)",
    },

    right: {
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      background: "#ffffff",
      marginTop:isMobile? "50px" : "",
    },

    logo: {
      position: "absolute",
      top: "30px",
      left: "40px",
      // width:"100px",
      fontSize: "22px",
      fontWeight: "600",
      color: "#6c2bd9",
    },
    heading:{
  display: isMobile ? "flex" : "",
  padding: "0 0 0 60px",
  fontSize: isMobile ? "24px" : "42px",
  fontWeight: "700",
  textAlign: "center",
  margin: isMobile ? "15vh auto 0 auto" : "20px 0 0 0",
  color: "#111",
  lineHeight: "1.3",
},

    highlight: {
      color: "#7c3aed",
    },

    subText: {
      padding: "0 0 0 60px",
      marginTop: "15px",
      color: "#555",
      fontSize: "16px",
      textAlign:"center",
      maxWidth: isMobile? "700px" : "100%",
    },

    card: {
      width: isMobile ? "320px" : "380px",
      padding: "35px",
      borderRadius: "18px",
      border: "1px solid #e5e0ff",
      boxShadow: "0 10px 30px rgba(124, 58, 237, 0.15)",
      background: "#fff",
        marginBottom:"50px"
    },

    codematrixlogo:{
height:"100px",
width:"100px"
    },

    cardTitle: {
      textAlign: "center",
      fontSize: "28px",
      fontWeight: "700",
      marginBottom: "10px",
      color: "#111",
    },

    cardSubtitle: {
      textAlign: "center",
      fontSize: "14px",
      color: "#666",
      marginBottom: "25px",
    },

    label: {
      fontSize: "14px",
      marginBottom: "6px",
      color: "#7c3aed",
      fontWeight: "500",
    },

    input: {
      width: "100%",
      padding: "12px 14px",
      marginBottom: "18px",
      borderRadius: "10px",
      border: "1px solid #ddd",
      outline: "none",
      fontSize: "14px",
    },

    wave:{
      display: isMobile ? "none" : "" , 
width:"100vw"
    },

    button: {
      width: "100%",
      padding: "13px",
      borderRadius: "12px",
      border: "none",
      background: "linear-gradient(135deg, #7c3aed, #6d28d9)",
      color: "#fff",
      fontSize: "15px",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "5px",
      cursor: "pointer",
      marginTop: "10px",
      transition: "0.3s",
    },

    footerText: {
      marginTop: "15px",
      fontSize: "12px",
      color: "#777",
      textAlign: "center",
    },
    copyright: {
      textAlign: "center"
    }
  };



  const navigate = useNavigate();

  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");

  const [loading, setLoading] = useState(false);

  // if otp appears
  const [ShowOTP, setShowOTP] = useState(false);
  const [getotp, setgetotp] = useState("");

  const Sendotp = async (e) => {
    e.preventDefault();

    // ✅ validation FIRST
    if (!email.trim() || !number.trim()) {
      toast.error("Please enter email and phone");
      return;
    }

    const toastId = toast.loading("Sending OTP...");

    try {
      setLoading(true);

      const res = await axiosClient.post(
        "/no-auth/api/users/send-login-otp-admin",
        null,
        {
          params: {
            phoneNumber: number,
            email: email,
          },
        }
      );

      console.log(res);

      setShowOTP(true);
      localStorage.setItem("adminname",email); 

    toast.success("OTP sent successfully 📩", {
      id: toastId,
    });

  } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to send OTP ❌",
        {
          id: toastId,
        }
      );

    } finally {
      setLoading(false);
    }
  };

  

  const handleSubmitOTP = async () => {

    if (!getotp) {
      toast.error("Enter OTP first");
      return;
    }

    const toastId = toast.loading("Verifying OTP...");

    try {
      setLoading(true);

      const res = await axiosClient.post(
        "/no-auth/api/users/verify-otp-admin",
        null,
        {
          params: {
            phoneNumber: number,
            otp: getotp,
          },
        }
      );

    console.log(res);

    localStorage.setItem("admintoken", res.data.data.token); // ✅ save token
      localStorage.setItem("adminrole", res.data.data.role); // ✅ save token

console.log("Saved Token:", res.data.data); // ✅ check token

    toast.success("OTP verified successfully 🎉", {
      id: toastId,
    });

    const token = localStorage.getItem("admintoken");
   
    setemail("");
    setnumber("");
    setgetotp("");
    setShowOTP(false);
console.log("CHECK TOKEN:", localStorage.getItem("admintoken"));
    // optional: navigate dashboard
    if(token){
 navigate("/AdminDashboard", {replace:true});
    }else{
       navigate("/login",{replace:true});
    }

  
   
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Invalid OTP ❌",
      {
        id: toastId,
      });


      setemail("");
      setnumber("");
      setgetotp("");
      setShowOTP(false);

      // optional: navigate dashboard
      navigate("/AdminDashboard");

    } finally {
      setLoading(false);
    }
  };

  // const token = localStorage.getItem("admintoken");




  return (
    <div className="containerr" style={styles.container}>

      <Toaster position="top-right" />
      {/* LEFT */}
     
      <div className="leftt" style={styles.left}>
        <div style={styles.logo} onClick={()=>navigate("/login")}><MoveLeft/> <img style={styles.codematrixlogo} src="codematrixLogo.png" alt="logo"/> </div>

        <h1 style={styles.heading}>
          Welcome back, <br />
          <span style={styles.highlight}>Admin</span>
        </h1>

        <p style={styles.subText}>
          Login securely to access and manage the CodeMatrix platform.
        </p>

        <img src={wave} style={styles.wave} alt="wave" />

        <div style={styles.copyright}>
          &copy; 2026 Codematrix. All Rights Reserved
        </div>
      </div>



      {/* RIGHT */}
      <div style={styles.right}>


        <div style={styles.card}>
          {/* <img src={logo} style={styles.logos} alt="logo" /> */}
          <h2 style={styles.cardTitle}>
            <span style={styles.highlight}>Admin</span> Portal
          </h2>

          <p style={styles.cardSubtitle}>
            Please enter your credentials to manage the platform.
          </p>

          <form onSubmit={Sendotp}>
            <div>
              <div style={styles.label}>Email Address</div>
              <input
                value={email}
                onChange={(e) => setemail(e.target.value)}
                type="email"
                placeholder="admin@xyz.edu"
                style={styles.input}
              />
            </div>

            <div>
              <div style={styles.label}>Phone Number</div>
              <input
                value={number}
                onChange={(e) => setnumber(e.target.value)}
                type="tel"
                placeholder="Enter your number"
                style={styles.input}
              />
            </div>

            <button
              type="submit"
              style={{
                ...styles.button,
                opacity: loading ? 0.7 : 1,
                cursor: loading ? "not-allowed" : "pointer",
              }}
              disabled={loading}
            >
              <Shield />
              {loading ? "Sending..." : "Send OTP"}
            </button>

    

</form>

{/* OTP Field (appears below button) */}
      {ShowOTP && (
        <div style={{ marginTop: "10px" }}>
          <input
            type="tel"
            placeholder="Enter 6 Digit OTP"
            value={getotp}
            onChange={(e) => setgetotp(e.target.value)}
            style={{
              width: "100%",
              padding: "8px",
              marginBottom: "10px"
            }}
          />

              <button style={styles.button} onClick={handleSubmitOTP}>
                Submit OTP
              </button>
            </div>
          )}

          <p style={styles.footerText}>
            Your data is 100% secure and encrypted.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;